module.exports = "::ng-deep .swal2-styled.swal2-confirm {\r\n    border: 0;\r\n    border-radius: .25em;\r\n    color: #000;\r\n    font-size: 1em;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/license-portal/glt/generate-glt-license/generate-glt-license.component.css
// module id = 970
// module chunks = 1